import { render, staticRenderFns } from "./AppSummernote.vue?vue&type=template&id=72edb98a&"
import script from "./AppSummernote.vue?vue&type=script&lang=js&"
export * from "./AppSummernote.vue?vue&type=script&lang=js&"
import style0 from "./AppSummernote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports